const parentBlock = document.querySelector('[data-anim="parent"]');
const breakpointSm = window.matchMedia('(min-width: 375px)');
const breakpointMd = window.matchMedia('(min-width: 768px)');
const breakpointIpad = window.matchMedia('(min-width: 834px)');
const breakpointLg = window.matchMedia('(min-width: 1024px)');
const breakpoint1280 = window.matchMedia('(min-width: 1280px)');
const breakpointXl = window.matchMedia('(min-width: 1440px)');
const breakpointXl2 = window.matchMedia('(min-width: 1690px)');
const breakpointXxl2 = window.matchMedia('(min-width: 1790px)');
const breakpointXxl = window.matchMedia('(min-width: 1920px)');

let windowHeight;
let stopPoint;

const calculateParallax = (el) => {
  if (scrollY < 1) {
    el.style.transform = 'translate3d(-50%, 0, 0)';
  } else {
    el.style.transform = `translate3d(-50%, ${scrollY * 0.9}px, 0)`;
  }
};

const initScrollAnimation = () => {
  windowHeight = window.innerHeight;
  const animItems = parentBlock.querySelectorAll('._anim-items');
  if (!animItems.length) {
    return;
  }
  animItems.forEach((el) => {
    if (scrollY <= stopPoint) {
      el.classList.remove('bottom');
      calculateParallax(el);
    } else {
      el.style.transform = `translate3d(-50%, ${stopPoint}px, 0)`;
      el.classList.add('bottom');
    }
  });
};

const initAnimation = () => {

  if (!parentBlock) {
    return;
  }

  const breakpointChecker = () => {
    if (breakpointXxl.matches) {
      stopPoint = parentBlock.offsetHeight / 1.93;
    } else if (breakpointXxl2.matches) {
      stopPoint = parentBlock.offsetHeight / 2.04;
    } else if (breakpointXl2.matches) {
      stopPoint = parentBlock.offsetHeight / 2.45;
    } else if (breakpointXl.matches) {
      stopPoint = parentBlock.offsetHeight / 1.96;
    } else if (breakpoint1280.matches) {
      stopPoint = parentBlock.offsetHeight / 1.95;
    } else if (breakpointLg.matches) {
      stopPoint = parentBlock.offsetHeight / 1.95;
    } else if (breakpointIpad.matches) {
      stopPoint = parentBlock.offsetHeight / 2.09;
    } else if (breakpointMd.matches) {
      stopPoint = parentBlock.offsetHeight / 2.09;
    } else if (breakpointSm.matches) {
      stopPoint = parentBlock.offsetHeight / 2.03;
    } else {
      stopPoint = parentBlock.offsetHeight / 3.03;
    }
    initScrollAnimation(stopPoint);
  };

  breakpointChecker();

  breakpointXl.addListener(breakpointChecker);
  breakpointLg.addListener(breakpointChecker);
  breakpointMd.addListener(breakpointChecker);
  breakpointSm.addListener(breakpointChecker);
  breakpointXxl.addListener(breakpointChecker);

  window.addEventListener('scroll', () => {
    initScrollAnimation(stopPoint);
  });
  window.addEventListener('orientationchange', () => {
    initScrollAnimation(stopPoint);
  });
};

export {initAnimation};
